import { render, staticRenderFns } from "./_SearchBar.vue?vue&type=template&id=651d4255&scoped=true&lang=pug&"
import script from "./_SearchBar.vue?vue&type=script&lang=js&"
export * from "./_SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./_SearchBar.vue?vue&type=style&index=0&id=651d4255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d4255",
  null
  
)

export default component.exports